/* import __COLOCATED_TEMPLATE__ from './voice-selector.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { FinVoiceVoice } from 'embercom/objects/ai-agent/fin-voice/fin-voice-voice-options';

interface Signature {
  Args: {
    availableVoices: Array<{ value: FinVoiceVoice; text: string }>;
    selectedVoice: FinVoiceVoice;
    isDisabled?: boolean;
    isProcessing?: boolean;
    hasVoices?: boolean;
    onSelectVoice: (voice: { value: FinVoiceVoice; text: string }) => void;
    onPlay: () => void;
  };
  Element: HTMLElement;
}

export default class VoiceSelector extends Component<Signature> {
  get hasVoices(): boolean {
    return this.args.hasVoices ?? false;
  }

  get isDisabled(): boolean {
    return this.args.isDisabled ?? false;
  }

  get isProcessing(): boolean {
    return this.args.isProcessing ?? false;
  }

  @action
  isVoiceSelected(voiceItem: { value: FinVoiceVoice; text: string }): boolean {
    return voiceItem.value === this.args.selectedVoice;
  }

  @action
  handlePlay(): void {
    this.args.onPlay();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::VoiceSelector': typeof VoiceSelector;
    'ai-agent/voice-playground/voice-selector': typeof VoiceSelector;
  }
}
